"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ConsoleTabbyAdapter = void 0;
exports.ConsoleTabbyAdapter = {
    log: (severity, payload) => {
        const { message, ...rest } = payload;
        switch (severity) {
            case "critical":
                // eslint-disable-next-line no-console
                return console.error("[tabby:critical]", message, rest);
            case "error":
                // eslint-disable-next-line no-console
                return console.error("[tabby:error]", message, rest);
            case "warn":
                // eslint-disable-next-line no-console
                return console.warn("[tabby:warn]", message, rest);
            case "info":
                // eslint-disable-next-line no-console
                return console.info("[tabby:info]", message, rest);
            case "debug":
                // eslint-disable-next-line no-console
                return console.log("[tabby:debug]", message, rest);
            case "trace":
                // eslint-disable-next-line no-console
                return console.log("[tabby:trace]", message, rest);
        }
    },
    injectContext: (payload, _dependencies, traceContext) => {
        if (traceContext === null)
            return payload;
        return { ...payload, traceID: traceContext.traceID };
    },
    getTraceContextFromMetadata: metadata => metadata,
};
//# sourceMappingURL=console_adapter.js.map